import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer} dir="rtl">
      <div className={styles.columns}>
        <div>
          <Link to="/"><img className={styles.logo} src="/assets/images/waterlessLogo.png" alt="ווטרלס - משתנות ללא מים" loading="lazy" /></Link>
          <p>משתנות ללא מים לעסקים ולמוסדות בישראל.</p>
          <Link className={styles.footerLink} to="/contact">בקשת הצעת מחיר</Link>
        </div>
        <nav aria-label="ניווט בתחתית האתר">
          <h2 className={styles.sectionTitle}>ניווט באתר</h2>
          <Link className={styles.footerLink} to="/">דף הבית</Link>
          <Link className={styles.footerLink} to="/שירותים-ירוקים">שירותים ירוקים</Link>
          <Link className={styles.footerLink} to="/השוואת-משתנות-ללא-מים">השוואת משתנות</Link>
          <Link className={styles.footerLink} to="/articles">מאמרים</Link>
          <Link className={styles.footerLink} to="/about">אודות החברה</Link>
          <Link className={styles.footerLink} to="/contact">צור קשר</Link>
        </nav>
        <div>
          <h2 className={styles.sectionTitle}>שמרו על קשר</h2>
          <p>צבי רוזנבלט 19, תל אביב</p>
          <a className={styles.footerLink} href="tel:0544494384" dir="ltr">0544494384</a>
          <a className={styles.footerLink} href="mailto:waterless.israel@gmail.com" dir="ltr">waterless.israel@gmail.com</a>
          <p>ראשון - חמישי 08:00-21:00</p>
          <a className={styles.footerLink} href="https://wa.me/972525970820" target="_blank" rel="noopener noreferrer">דברו איתנו בוואטסאפ</a>
        </div>
      </div>
      <div className={styles.copyright}><span dir="ltr">Copyright {new Date().getFullYear()} Waterless Inc</span></div>
    </footer>
  );
}
export default Footer;
